module.exports = __webpack_public_path__ + "ML.png?38c1d857c89c21c1dcd393300a10ad28";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/ML.png
// module id = 382
// module chunks = 0